import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './stat-box.module.scss'

const StatBox = ({ stat, text, className }) => (
  <div className={ classNames( styles.box, className ) }>
    <p className={ styles.stat }>{ stat }</p>

    { text && (
      <p className={ styles.text }>{ text }</p>
    )}
  </div>
)

StatBox.propTypes = {
  stat: PropTypes.string.isRequired,
  text: PropTypes.string,
}

export default StatBox